import React from "react";
import PropTypes from "prop-types";
import FormTextField from "components/form/form-textfield";
import { injectIntl } from "react-intl";
import { DataGridItem } from "components/data-grid";
import { AssetCategorySelect } from "components/select";

const EditAssetForm = ({ intl, values, handleChange, defaultCategories }) => (
  <>
    <DataGridItem big>
      <AssetCategorySelect
        id="categoryIds"
        name="categoryIds"
        isInsideForm
        label={intl.formatMessage({ id: "common.asset.selectCategory" })}
        onChange={handleChange}
        multiple
        value={values.categoryIds}
        defaultCategories={defaultCategories}
      />
    </DataGridItem>
    <DataGridItem big>
      <FormTextField
        type="text"
        id="codename"
        name="codename"
        value={values.codename}
        onChange={handleChange}
        label={intl.formatMessage({ id: "common.name" })}
      />
    </DataGridItem>
    <DataGridItem big>
      <FormTextField
        type="text"
        id="description"
        name="description"
        value={values.description}
        onChange={handleChange}
        label={intl.formatMessage({ id: "common.description" })}
      />
    </DataGridItem>
  </>
);

EditAssetForm.propTypes = {
  /**
   * Valores del formulario
   */
  values: PropTypes.object,
  /**
   * Callback que se dispara con el cambio del input
   */
  handleChange: PropTypes.func,
  /**
   * Categorías por defecto para la creación del asset
   */
  defaultCategories: PropTypes.arrayOf(PropTypes.string),
};

export default injectIntl(EditAssetForm);
